import { ApiProperty } from "@nestjs/swagger";

export class EndCustomerReq{
    @ApiProperty()
    endCustomerId : number;
    @ApiProperty()
    fromDate : Date;
    @ApiProperty()
    toDate: Date;
    @ApiProperty()
    unitId : number;
}